import React, { useEffect, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SectionTitle from '../../SectionTitle';

import OrderCard from '../../OrderCard';
// Styles
import styles from './index.module.sass';

import getData from '../../Queries/getData';
import getCookie from '../../Queries/getCookie';

export default function ConsultData(props) {
  const { device, setSessionMessage } = props;
  const screenSize = device?.screenSize || 'desktop';
  const [data, setData] = useState({});
  const { t } = useTranslation('contractMXData');

  const fetchData = useCallback(async () => {
    const jsonBody = {
      accion: '',
      usuarioOK: getCookie('usuarioOk'),
    };
    const resp = await getData({ jsonBody });
    setData(resp);
    setSessionMessage(resp.mensaje);
  }, [setSessionMessage]);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchData();
  }, [fetchData]);

  return (
    <div className={`${styles.consult} ${styles[screenSize]}`}>
      <SectionTitle title={t('captureGold')} subtitle={t('captureBlue')} />
      <div className={screenSize === 'desktop' ? styles.container : styles.containerMobile}>
        <OrderCard>
          <div className={styles.orderDet}>
            <div className={styles.cardText}>
              <div className={styles.textIcon}>
                <i className={`material-icons-outlined ${styles.icon}`}>account_box </i>
                <label className={styles.iconText}>{t('PersonalData')}</label>
              </div>
            </div>
            <div className={styles.item} name='RowKit'>
              <div className={screenSize === 'desktop' ? styles.title : styles.titleMobile}>
                <div
                  className={screenSize === 'desktop' ? styles.sizeLabel : styles.sizeLabelMobile}>
                  <label className={styles.labelBlue}>{t('kit')}</label>
                </div>
                <label className={styles.labelGray}>{data.usuarioOK}</label>
              </div>
              <div className={screenSize === 'desktop' ? styles.title : styles.titleMobile}>
                <div
                  className={screenSize === 'desktop' ? styles.sizeLabel : styles.sizeLabelMobile}>
                  <label className={styles.labelBlue}>{t('name')}</label>
                </div>
                <label className={styles.labelGray}>{data.nombre + ' ' + data.paterno}</label>
              </div>
              <div className={screenSize === 'desktop' ? styles.title : styles.titleMobile}>
                <div
                  className={screenSize === 'desktop' ? styles.sizeLabel : styles.sizeLabelMobile}>
                  <label className={styles.labelBlue}>{t('dateOfBirth')}</label>{' '}
                </div>
                <label className={styles.labelGray}>{data.fechaNac}</label>
              </div>
              <div className={screenSize === 'desktop' ? styles.title : styles.titleMobile}>
                <div
                  className={screenSize === 'desktop' ? styles.sizeLabel : styles.sizeLabelMobile}>
                  <label className={styles.labelBlue}>{t('sexo')}</label>{' '}
                </div>
                <label className={styles.labelGray}>{data.sexo}</label>
              </div>
              <div className={screenSize === 'desktop' ? styles.title : styles.titleMobile}>
                <div
                  className={screenSize === 'desktop' ? styles.sizeLabel : styles.sizeLabelMobile}>
                  <label className={styles.labelBlue}>RFC:</label>
                </div>
                <label className={styles.labelGray}>{data.rfc}</label>
              </div>
              <div className={screenSize === 'desktop' ? styles.title : styles.titleMobile}>
                <div
                  className={screenSize === 'desktop' ? styles.sizeLabel : styles.sizeLabelMobile}>
                  <label className={styles.labelBlue}>Kit de patrocinadora:</label>
                </div>
                <label className={styles.labelGray}>
                  {data.kitPatrocinadora + ' ' + data.nombrePatrocinadora}
                </label>
              </div>
              <div className={screenSize === 'desktop' ? styles.title : styles.titleMobile}>
                <div
                  className={screenSize === 'desktop' ? styles.sizeLabel : styles.sizeLabelMobile}>
                  <label className={styles.labelBlue}>{t('mail')}</label>
                </div>
                <label className={styles.labelGray}>{data.email}</label>
              </div>
            </div>
          </div>
        </OrderCard>
        <OrderCard>
          <div className={styles.orderDet}>
            <div className={styles.cardText}>
              <div className={styles.textIcon}>
                <i className={`material-icons-outlined ${styles.icon}`}>home</i>
                <label className={styles.iconText}>{t('home')}</label>
              </div>
            </div>
            <div className={styles.item} name='RowKit'>
              <div className={screenSize === 'desktop' ? styles.title : styles.titleMobile}>
                <div
                  className={screenSize === 'desktop' ? styles.sizeLabel : styles.sizeLabelMobile}>
                  <label className={styles.labelBlue}>{t('street')}</label>
                </div>
                <label className={styles.labelGray}>{data.calle}</label>
              </div>
              <div className={screenSize === 'desktop' ? styles.title : styles.titleMobile}>
                <div
                  className={screenSize === 'desktop' ? styles.sizeLabel : styles.sizeLabelMobile}>
                  <label className={styles.labelBlue}>{t('outdoorNumber')}</label>
                </div>
                <label className={styles.labelGray}>{data.numeroExterior}</label>
              </div>
              <div className={screenSize === 'desktop' ? styles.title : styles.titleMobile}>
                <div
                  className={screenSize === 'desktop' ? styles.sizeLabel : styles.sizeLabelMobile}>
                  <label className={styles.labelBlue}>{t('interiorNumber')}</label>{' '}
                </div>
                <label className={styles.labelGray}>{data.numeroInterior}</label>
              </div>
              <div className={screenSize === 'desktop' ? styles.title : styles.titleMobile}>
                <div
                  className={screenSize === 'desktop' ? styles.sizeLabel : styles.sizeLabelMobile}>
                  <label className={styles.labelBlue}>{t('zone')}</label>{' '}
                </div>
                <label className={styles.labelGray}>{data.manzana}</label>
              </div>
              <div className={screenSize === 'desktop' ? styles.title : styles.titleMobile}>
                <div
                  className={screenSize === 'desktop' ? styles.sizeLabel : styles.sizeLabelMobile}>
                  <label className={styles.labelBlue}>{t('Edifice')}</label>
                </div>
                <label className={styles.labelGray}>{data.edificio}</label>
              </div>
              <div className={screenSize === 'desktop' ? styles.title : styles.titleMobile}>
                <div
                  className={screenSize === 'desktop' ? styles.sizeLabel : styles.sizeLabelMobile}>
                  <label className={styles.labelBlue}>{t('lote')}</label>
                </div>
                <label className={styles.labelGray}>{data.lote}</label>
              </div>
              <div className={screenSize === 'desktop' ? styles.title : styles.titleMobile}>
                <div
                  className={screenSize === 'desktop' ? styles.sizeLabel : styles.sizeLabelMobile}>
                  <label className={styles.labelBlue}>{t('dpto')}</label>
                </div>
                <label className={styles.labelGray}>{data.depCasa}</label>
              </div>
              <div className={screenSize === 'desktop' ? styles.title : styles.titleMobile}>
                <div
                  className={screenSize === 'desktop' ? styles.sizeLabel : styles.sizeLabelMobile}>
                  <label className={styles.labelBlue}>{t('cp')}</label>
                </div>
                <label className={styles.labelGray}>{data.cp}</label>
              </div>
              <div className={screenSize === 'desktop' ? styles.title : styles.titleMobile}>
                <div
                  className={screenSize === 'desktop' ? styles.sizeLabel : styles.sizeLabelMobile}>
                  <label className={styles.labelBlue}>Colonia:</label>
                </div>
                <label className={styles.labelGray}>{data.colonia}</label>
              </div>
              <div className={screenSize === 'desktop' ? styles.title : styles.titleMobile}>
                <div
                  className={screenSize === 'desktop' ? styles.sizeLabel : styles.sizeLabelMobile}>
                  <label className={styles.labelBlue}>{t('state')}</label>
                </div>
                <label className={styles.labelGray}>{data.estadoDescri}</label>
              </div>
              <div className={screenSize === 'desktop' ? styles.title : styles.titleMobile}>
                <div
                  className={screenSize === 'desktop' ? styles.sizeLabel : styles.sizeLabelMobile}>
                  <label className={styles.labelBlue}>{t('street1')}</label>
                </div>
                <label className={styles.labelGray}>{data.entreCalle}</label>
              </div>
              <div className={screenSize === 'desktop' ? styles.title : styles.titleMobile}>
                <div
                  className={screenSize === 'desktop' ? styles.sizeLabel : styles.sizeLabelMobile}>
                  <label className={styles.labelBlue}>{t('street2')}</label>
                </div>
                <label className={styles.labelGray}>{data.yLaCalle}</label>
              </div>
            </div>
          </div>
        </OrderCard>
        <OrderCard>
          <div className={styles.orderDet}>
            <div className={styles.cardText}>
              <div className={styles.textIcon}>
                <i className={`material-icons-outlined ${styles.icon}`}>contact_phone</i>
                <label className={styles.iconText}>{t('contact')}</label>
              </div>
            </div>
            <div className={styles.item} name='RowKit'>
              <div className={screenSize === 'desktop' ? styles.title : styles.titleMobile}>
                <div
                  className={screenSize === 'desktop' ? styles.sizeLabel : styles.sizeLabelMobile}>
                  <label className={styles.labelBlue}>{t('tel1')}</label>
                </div>
                <label className={styles.labelGray}>{data.telefonoCasa}</label>
              </div>
              <div className={screenSize === 'desktop' ? styles.title : styles.titleMobile}>
                <div
                  className={screenSize === 'desktop' ? styles.sizeLabel : styles.sizeLabelMobile}>
                  <label className={styles.labelBlue}>{t('tel2')}</label>
                </div>
                <label className={styles.labelGray}>{data.celular}</label>
              </div>
              <div className={screenSize === 'desktop' ? styles.title : styles.titleMobile}>
                <div
                  className={screenSize === 'desktop' ? styles.sizeLabel : styles.sizeLabelMobile}>
                  <label className={styles.labelBlue}>{t('office')}</label>
                </div>
                <label className={styles.labelGray}>{data.telefonoOficina}</label>
              </div>
            </div>
          </div>
        </OrderCard>
      </div>
    </div>
  );
}
